import { all, call } from 'typed-redux-saga';

import AllowFCMSaga from '~/sagas/AllowFCMSaga';
import ContentsSettingSaga from '~/sagas/ContentsSettingSaga';
import LocalStorageSaga from '~/sagas/LocalStorageSaga';
import LogActionSaga from '~/sagas/LogActionSaga';
import ManageFCMSaga from '~/sagas/ManageFCMSaga';

/**
 * root saga
 *
 * @yields
 * @returns {Generator} saga generator
 */

// API 요청 내용 주석 처리
/**
 *     //     call(LocalStorageSaga),
 *     //     call(ManageFCMSaga),
 *     //     call(AllowFCMSaga),
 *     //     call(ContentsSettingSaga),
 *
 */
function* rootSaga(): Generator {
    // yield all([call(LogActionSaga)]);
}

export default rootSaga;
